<template>
  <l-cache :get-data="getInstitution" :id="$route.query.id" ref="cache">
    <institution-form :institution="data" @refresh="$refs.cache.retry(true)" slot-scope="{data}"></institution-form>
  </l-cache>
</template>

<script>
import InstitutionForm from './institutionForm'
export default {
  name: 'EditInstitution',
  components: {InstitutionForm},
  methods: {
    async getInstitution () {
      let {items} = await this.$store.dispatch('userAdmin/getInstitutions', {
        pagination: {},
        filter: [{key: 'id', value: this.$route.query.id}]
      })
      if (items && items.length > 0) {
        let p = items[0]
        return p
      }
      else {
        throw Error('未找到该机构')
      }
    },
  }
}
</script>

<style scoped>

</style>
